import React, { useState } from 'react'
import { teamsBasicArray } from '../../../../Constant/team'
import { colors } from '../../../consts'
import { CustomSelect } from '../../../Layout'

type TypeSelectProps = {
  current: string | undefined
  onChangeTeam: (favTeam: string) => void
  color?: string
}

/**
 * Select year from allowed range
 */
export const TeamSelect: React.FC<React.PropsWithChildren<TypeSelectProps>> = ({
  current,
  onChangeTeam,
  color = colors.yellow,
}) => {
  const startVal = current
    ? current.charAt(0).toUpperCase() + current.slice(1)
    : 'Archers'
  const [value, setValue] = useState<string>(startVal)

  const onChange = (option: string) => {
    onChangeTeam(option)
    setValue(option)
  }

  return (
    <CustomSelect
      options={teamsBasicArray.map((ty) => ty.fullName)}
      value={value}
      onChange={onChange}
      id="team-select"
      ariaLabel="Team select"
    />
  )
}
